import axios from 'axios';
;

const Token = localStorage.getItem("token");

// const api = "http://3.110.246.54:8080/"
const api = "https://tailorforubackend.vibhohcm.com/"
// const api = "http://localhost:8080/"
// const api = "https://backend.tailors4u.com/"


const createAxiosInstance = (token) => {
    return axios.create({
        baseURL: `${api}/`,
        headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
            "x-token": Token,
        }
    })

}

export const instance = createAxiosInstance(Token);

export const updatedToken = (newToken) => {
    instance.defaults.headers["Authorization"] = `Bearer ${newToken.trim()}`;
    instance.defaults.headers["x-token"] = newToken;
}
// instance.interceptors.response.use(
//     response => response,
//     error => {
//         if (error.response && error.response.status === 401) {
//             localStorage.clear();
//             window.location.href = '/admin/login';
//         }
//         return Promise.reject(error);
//     }
// );
export default instance;